import React from 'react';
import ConsentModal from './consent-modal';
import { getPurposes } from '../utils/config';
import Text from './text';
import { asTitle } from '../utils/strings';

export default class ConsentNotice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: props.modal,
            confirming: false,
        };
    }

    componentDidMount() {
        if (this.props.config.autoFocus && this.noticeRef) {
            this.noticeRef.focus()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.modal !== this.props.modal)
            this.setState({ modal: this.props.modal });

        if (this.noticeRef) {
            this.noticeRef.focus();
        }
    }

    executeButtonClicked = (setChangedAll, changedAllValue, eventType) => {
        const { modal } = this.state;

        let changedServices = 0;

        if (setChangedAll)
            changedServices = this.props.manager.changeAll(changedAllValue);

        const confirmed = this.props.manager.confirmed;

        this.props.manager.saveAndApplyConsents(eventType);
        document.documentElement.classList.remove('klaro-modal-open');

        if (
            setChangedAll &&
            !confirmed &&
            (modal || this.props.config.mustConsent)
        ) {
            const close = () => {
                this.setState({ confirming: false });
                this.props.hide();
            };

            this.setState({ confirming: true });
            if (changedServices === 0) close();
            else {
                setTimeout(close, 800);
            }
        } else {
            this.props.hide();
            /*
            evtl. einbauen?
            div = document.createElement( 'div' );
            div.id = 'klaro_trigger';
            div.onclick = function() {
                klaro.show();
            };
            div.setAttribute( 'title', 'Datenschutz-Optionen einblenden' )
            div.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="klaro_shadow" width="80" height="80" viewBox="-229.6 406.2 100 100">' +
                '<path d="M-179.7 424.4c10.8 6.8 20.6 10.1 29 9.3 1.5 29.6-9.5 47-28.9 54.3 -18.8-6.8-29.8-23.5-29-54.7C-198.8 433.8-189.1 431.7-179.7 424.4z" fill="#95a627"/>' +
                '<path d="M-188.1 449.5h0.9v-2c0-2.2 0.9-4.2 2.3-5.7 1.4-1.5 3.4-2.4 5.6-2.4s4.1 0.9 5.6 2.4c1.4 1.5 2.3 3.5 2.3 5.7v2h0.9c0.7 0 1.3 0.6 1.3 1.3v13.5c0 0.7-0.6 1.3-1.3 1.3h-17.4c-0.7 0-1.3-0.6-1.3-1.3V450.8C-189.4 450.1-188.8 449.5-188.1 449.5zM-184.8 449.5h10.8v-2c0-1.6-0.6-3-1.6-4 -1-1-2.3-1.7-3.8-1.7 -1.5 0-2.8 0.6-3.8 1.7 -1 1-1.6 2.5-1.6 4V449.5zM-180.5 458.4l-1.4 3.6h4.9l-1.3-3.7c0.8-0.4 1.4-1.3 1.4-2.2 0-1.4-1.1-2.5-2.5-2.5 -1.4 0-2.5 1.1-2.5 2.5 0 1 0.6 1.9 1.5 2.3H-180.5z" fill="#FFF"/>' +
                '</svg>'
            document.body.appendChild( div );
             */
        }
    };

    saveAndHide = () => {
        this.executeButtonClicked(false, false, 'save');
    };

    acceptAndHide = () => {
        this.executeButtonClicked(true, true, 'accept');
    };

    declineAndHide = () => {
        this.executeButtonClicked(true, false, 'decline');
    };

    render() {
        const { lang, config, show, manager, testing, t } = this.props;
        const { confirming, modal } = this.state;
        const { embedded, noticeAsModal, hideLearnMore } = config;

        // we exclude functional services from this list, as they are always required and
        // the user cannot decline their use...
        const purposeOrder = config.purposeOrder || [];
        const purposes = getPurposes(config)
            .filter((purpose) => purpose !== 'functional')
            .sort((a, b) => purposeOrder.indexOf(a) - purposeOrder.indexOf(b));
        const purposesTranslations = purposes.map(
            (purpose) =>
                t(['!', 'purposes', purpose, 'title?']) || asTitle(purpose)
        );
        let purposesText = '';
        if (purposesTranslations.length === 1)
            purposesText = purposesTranslations[0];
        else
            purposesText = [
                ...purposesTranslations.slice(0, -2),
                purposesTranslations.slice(-2).join(' & '),
            ].join(', ');
        let ppUrl;
        // to do: deprecate and remove this
        if (config.privacyPolicy !== undefined) {
            if (typeof config.privacyPolicy === 'string')
                ppUrl = config.privacyPolicy;
            else if (typeof config.privacyPolicy === 'object') {
                ppUrl =
                    config.privacyPolicy[lang] || config.privacyPolicy.default;
            }
        } else {
            // this is the modern way
            ppUrl = t(['!', 'privacyPolicyUrl'], { lang: lang });
            if (ppUrl !== undefined) ppUrl = ppUrl.join('');
        }

        const showModal = (e) => {
            e.preventDefault();
            this.setState({ modal: true });
        };

        const hideModal = () => {
            if (config.mustConsent && !config.acceptAll) return;
            if (manager.confirmed && !testing) this.props.hide();
            else this.setState({ modal: false });

            document.documentElement.classList.remove('klaro-modal-open');
            setTimeout(() => {
                if (this.noticeRef) {
                    this.noticeRef.focus();
                }
            }, 1);
        };

        let changesText;
        if (manager.changed)
            changesText = (
                <p className="cn-changes">
                    {t(['consentNotice', 'changeDescription'])}
                </p>
            );

        // we only show the notice if it's explicitly demanded (show=True), if
        // testing mode is enabled (testing=true) or if there's a confirmation
        // process/animation going on (confirming=true)
        if (!show && !testing && !confirming) return <></>;

        const noticeIsVisible =
            (!config.mustConsent || noticeAsModal) &&
            !manager.confirmed &&
            !config.noNotice;

        const declineButton = config.hideDeclineAll ? (
            ''
        ) : (
            <button
                className="cm-btn cm-btn-danger cn-decline"
                type="button"
                onClick={this.declineAndHide}
            >
                {t(['decline'])}
            </button>
        );

        const acceptButton = config.acceptAll ? (
            <button
                className="cm-btn cm-btn-success"
                type="button"
                onClick={this.acceptAndHide}
            >
                {t(['ok'])}
            </button>
        ) : (
            <button
                className="cm-btn cm-btn-success"
                type="button"
                onClick={this.saveAndHide}
            >
                {t(['ok'])}
            </button>
        );

        const learnMoreLink = () =>
            noticeAsModal ? (
                <button
                    key="learnMoreLink"
                    className="cm-btn cm-btn-lern-more cm-btn-info"
                    type="button"
                    onClick={showModal}
                >
                    {t(['consentNotice', 'learnMore'])}
                </button>
            ) : (
                <a
                    key="learnMoreLink"
                    className="cm-link cn-learn-more"
                    href="#"
                    onClick={showModal}
                >
                    {t(['consentNotice', 'learnMore'])}
                </a>
            );

        let ppLink;

        if (ppUrl !== undefined)
            ppLink = (
                <a key="ppLink" href={ppUrl}>
                    {t(['privacyPolicy', 'name'])}
                </a>
            );

        if (
            modal ||
            (manager.confirmed && !testing) ||
            (!manager.confirmed && config.mustConsent)
        )
            return (
                <ConsentModal
                    t={t}
                    lang={lang}
                    config={config}
                    hide={hideModal}
                    confirming={confirming}
                    declineAndHide={this.declineAndHide}
                    saveAndHide={this.saveAndHide}
                    acceptAndHide={this.acceptAndHide}
                    manager={manager}
                />
            );

        const labeleldBy = (t(['!', 'consentNotice', 'title']) && config.showNoticeTitle) ? 'id-cookie-title' : null;
        const notice = (
            <div
                role="dialog"
                aria-describedby="id-cookie-notice"
                aria-labelledby={labeleldBy}
                aria-label={!labeleldBy ? 'Cookie-Einstellungen' : null}
                id="klaro-cookie-notice"
                tabIndex="0"
                autofocus={config.autoFocus}
                ref={(div) => {
                    this.noticeRef = div;
                }}
                className={`cookie-notice ${
                    !noticeIsVisible && !testing ? 'cookie-notice-hidden' : ''
                } ${noticeAsModal ? 'cookie-modal-notice' : ''} ${
                    embedded ? 'cn-embedded' : ''
                }`}
            >
                <div className="cn-body">
                    {t(['!', 'consentNotice', 'title']) && config.showNoticeTitle && (
                        <h2 id="id-cookie-title">
                            {t(['consentNotice', 'title'])}
                        </h2>
                    )}
                    <p id="id-cookie-notice">
                        <Text
                            config={config}
                            text={t(['consentNotice', 'description'], {
                                purposes: (
                                    <strong key="strong">{purposesText}</strong>
                                ),
                                privacyPolicy: ppLink,
                                learnMoreLink: learnMoreLink(),
                            })}
                        />
                    </p>
                    {testing && <p>{t(['consentNotice', 'testing'])}</p>}
                    {changesText}
                    <div className="cn-ok">
                        {!hideLearnMore && learnMoreLink()}
                        <div className="cn-buttons">
                            {declineButton}
                            {acceptButton}
                        </div>
                    </div>
                </div>
            </div>
        );

        if (!noticeAsModal) return notice;

        return (
            <div id="cookieScreen" className="cookie-modal">
                <div className="cm-bg" />
                {notice}
            </div>
        );
    }
}
